import { MemoizedSelector, createFeatureSelector } from '@ngrx/store';
import { SOLD_TO_FEATURE, SoldToState, StateWithSoldTo } from '../sold-to-state';

export const getSoldToState: MemoizedSelector<StateWithSoldTo, SoldToState> = createFeatureSelector<SoldToState>(SOLD_TO_FEATURE);
